<template>
  <div class="logo">
    <NuxtLink to="/" class="d-flex">
      <!-- <img src="/images/logos/white-logo-icon.svg" /> -->
      <!-- <img src="/images/logos/white-logo-text.svg" class="pl-3" /> -->
    </NuxtLink>
  </div>
</template>
<script setup lang="ts"></script>
